// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MentionPill - Inline pill for @mentions in messages */

.mention-pill {
  display: inline-flex;
  align-items: center;
  background: rgba(222, 71, 86, 0.5);
  border-radius: 6px;
  padding: 2px 6px;
  cursor: pointer;
  vertical-align: baseline;
  text-decoration: none;
  transition: background-color 0.15s ease;
}

.mention-pill:hover {
  background: rgba(222, 71, 86, 0.6);
}

.mention-pill:focus {
  outline: 2px solid rgba(222, 71, 86, 0.5);
  outline-offset: 1px;
}

.mention-pill-avatar {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  margin-right: 4px;
  object-fit: cover;
  flex-shrink: 0;
}

.mention-pill .mention-pill-text {
  font-size: 14px;
  line-height: 20px;
  color: #000;
  font-weight: 600;
  white-space: nowrap;
}

/* Ensure visibility on different message bubble backgrounds */
.message-bubble.user .mention-pill {
  background: rgba(255, 255, 255, 0.2);
}

.message-bubble.user .mention-pill:hover {
  background: rgba(255, 255, 255, 0.3);
}

.message-bubble.user .mention-pill-text {
  color: #fff;
}

.mention-pill-mxid {
  font-weight: normal;
  font-size: 11px;
  opacity: 0.7;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 160px;
}
`, "",{"version":3,"sources":["webpack://./src/components/MentionPill/MentionPill.css"],"names":[],"mappings":"AAAA,wDAAwD;;AAExD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB","sourcesContent":["/* MentionPill - Inline pill for @mentions in messages */\n\n.mention-pill {\n  display: inline-flex;\n  align-items: center;\n  background: rgba(222, 71, 86, 0.5);\n  border-radius: 6px;\n  padding: 2px 6px;\n  cursor: pointer;\n  vertical-align: baseline;\n  text-decoration: none;\n  transition: background-color 0.15s ease;\n}\n\n.mention-pill:hover {\n  background: rgba(222, 71, 86, 0.6);\n}\n\n.mention-pill:focus {\n  outline: 2px solid rgba(222, 71, 86, 0.5);\n  outline-offset: 1px;\n}\n\n.mention-pill-avatar {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  margin-right: 4px;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.mention-pill .mention-pill-text {\n  font-size: 14px;\n  line-height: 20px;\n  color: #000;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n/* Ensure visibility on different message bubble backgrounds */\n.message-bubble.user .mention-pill {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.message-bubble.user .mention-pill:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.message-bubble.user .mention-pill-text {\n  color: #fff;\n}\n\n.mention-pill-mxid {\n  font-weight: normal;\n  font-size: 11px;\n  opacity: 0.7;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 160px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
